import $ from "jquery";

document.addEventListener("DOMContentLoaded", function () {
  $(".AppLoginChallengesSmsVerifications--new").ready(function () {
    $(".form-container").autoFadeIn();
  });
});
